import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Tick.scss';
import { Icon, SIZE } from '../icon/Icon';
export function Tick(props) {
    let className = '';
    className += props.type === 'radio' ? ' sg-tick-radio' : '';
    className += props.type === 'checkbox' ? ' sg-tick-checkbox' : '';
    className += props.type === 'checkbox-exclusive' ? ' sg-tick-exclusiveCheckbox' : '';
    className += props.isHovered ? ' sg-tick-isHovered' : '';
    return (_jsxs("span", { className: 'sg-tick' + className, style: {
            // @ts-ignore
            '--SG_TICK_COLOR': props.color,
        }, onClick: props.onClick, children: [props.children, _jsx("span", { className: 'sg-tick--icon', children: props.icon && _jsx(Icon, { element: props.icon, size: SIZE.MED }) })] }));
}
//# sourceMappingURL=Tick.js.map